import React, { useState, useEffect } from "react";
import style from "./TableCellColorPicker.scss";

export default function TableCellColorPicker(props)
{
    let { colors, onUpdate } = props;

    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(props.value);

    useEffect(
        () => {
            setValue(props.value)
        },
        [props.value]
    );

    useEffect(() => {
        document.addEventListener(
            "keydown",
            () => {
                // escape
                if(event.keyCode !== 27) {
                    return;
                }

                setOpen(false);
            }
        );
    });

    let colorElements = [];
    for (let i = 0; i < colors.length; i++) {
        colorElements.push(
            <div className={style.colorBlock}
                 style={{ backgroundColor: colors[i] }}
                 key={"tableCellColorPicker" + colors[i]}
                 onClick={ () => { setValue(colors[i]); setOpen(false); onUpdate(colors[i]); } }
            />
        );
    }

    return <div className={style.tableCellColorPicker + " " + (open ? style.open : "")}>
        <button className={style.currentValue} style={{backgroundColor: value}} onClick={() => setOpen(!open)} />
        <div className={style.overview}>{colorElements}</div>
    </div>;
}
